import { STATUTS_COMMANDE } from "@/utils/statut-commande";

export const pageMonCompteMesCommandesProps = () => ({
  commandes: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  },
  hasArchive: {
    type: Boolean,
    required: false,
    default: false
  },
  hasCarteCarrefour: {
    type: Boolean,
    required: false,
    default: false
  },
  isFidCarrefour: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const usePageMonCompteMesCommandes = (props) => {
  const commandesEnCours = computed(() => {
    return props.commandes.filter(commande => commande.attributes.statut_code === STATUTS_COMMANDE.commandee);
  })
  const dernieresCommandes = computed(() => {
    return props.commandes.filter(commande => commande.attributes.statut_code !== STATUTS_COMMANDE.commandee).slice(0, 5);
  })
  const showToutesCommandes = computed(() => {
    const nbDernieresCommandes = props.commandes.filter(commande => commande.attributes.statut_code !== STATUTS_COMMANDE.commandee).length;
    return props.hasArchive || (nbDernieresCommandes > dernieresCommandes.value.length);
  })

  const canDisplayBanner = computed(() => {
    return (
      props.hasCarteCarrefour &&
      props.isFidCarrefour &&
      props.commandes.length > 0
    );
  });

  return {
    commandesEnCours,
    dernieresCommandes,
    showToutesCommandes,
    canDisplayBanner
  }
}